import React, { memo, useCallback, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import find from 'lodash/find';
import Grid from '@active/react-ui/Grid';
import GridItem from '@active/react-ui/GridItem';
import FormGroup from '@active/react-ui/FormGroup';
import FormField from '@active/react-ui/FormField';
import Checkbox from '@active/react-ui/Checkbox';
import CheckboxGroup from '@active/react-ui/CheckboxGroup';
import StaticField from '../../../../../../../../staticFields/PaymentInfoFields/components/StaticField';
import { IMAGE_VALUES } from '../../../../../../../../staticFields/PaymentInfoFields/components/CreditCardInfoField/CreditCardInfoField';
import CurrencyInputFormField from '../../../CurrencyInputFormField';
import { updatePaymentsInfoUsedForPay, deletePaymentsInfoUsedForPay } from '../../../../../paymentMethodsSlice';

const CreditCardItem = ({
  expirationDate, currencyCode, maskedNumber, index, isPrefillValue = false, id, paymentMethodType,
}) => {
  const [ isShowAmountField, setIsShowAmountField ] = useState(true);
  const [ currentAmount, setCurrentAmount ] = useState('');
  const dispatch = useDispatch();
  const {
    paymentsInfoUsedForPay,
  } = useSelector(state => state.paymentMethods);

  const handleCurrencyAmountChange = useCallback((value) => {
    setCurrentAmount(value);
  }, []);

  const handleCheckBoxChange = useCallback((value) => {
    const isSelected = !isEmpty(value);
    setIsShowAmountField(isSelected);
    if (!isSelected) {
      const findObj = find(paymentsInfoUsedForPay, { paymentMethodType, paymentAccountId: id });
      if (!findObj) { return; }
      dispatch(deletePaymentsInfoUsedForPay({
        paymentMethodType,
        paymentAccountId: id,
      }));
    } else if (currentAmount === 0 || currentAmount > 0) {
      dispatch(updatePaymentsInfoUsedForPay({
        paymentInfoObj: {
          paymentMethodType,
          amount: Number(currentAmount),
          paymentAccountId: id,
        },
        findPaymentConfig: {
          paymentMethodType,
          paymentAccountId: id,
        },
      }));
    }
  }, [ setIsShowAmountField, paymentMethodType, id, dispatch, paymentsInfoUsedForPay, currentAmount ]);

  return <div className='credit-card-item'>
    <Grid gap={0} align='center' justify='end'>
      <GridItem span={12} spanMd={6} >
        <FormGroup name={`creditCardCheck_${index}`} className='credit-card-item__check'>
          <FormField as={CheckboxGroup} disabled={isPrefillValue} onChange={handleCheckBoxChange}>
            <Checkbox value="true" >
              <div className="credit-card-item__text">
                <StaticField
                  values={IMAGE_VALUES}>
                  {maskedNumber}
                </StaticField>
                <div className='text-expire-date cui-mg-l-16'>
                  { expirationDate }
                </div>
              </div>
            </Checkbox>
          </FormField>
        </FormGroup>
      </GridItem>
      <GridItem span={12} spanMd={6} >
        <div className='credit-card-item__amount'>
          {isShowAmountField && <CurrencyInputFormField
            onChange={handleCurrencyAmountChange}
            paymentAccountId={id}
            paymentMethodType={paymentMethodType}
            isPrefillValue={isPrefillValue}
            name={`creditCardAmount_${index}`}
            disabled={isPrefillValue}
            code={currencyCode}/>}
        </div>
      </GridItem>
    </Grid>
  </div>;
};

export default memo(CreditCardItem);
